<template>
  <div class="order cont_bg" style="padding-bottom: 2rem">
    <navs :lang="false" :saver="false" :mess="true" />
    <div class="order_con">
      <div class="tabs">
        <span class="tabs_item" @click="tabsFun(1)" :class="tabsActive === 1 ? 'tabs_active' : ''">{{
          $t('cont.t02')
        }}</span>
        <span class="tabs_item" @click="tabsFun(2)" :class="tabsActive === 2 ? 'tabs_active' : ''">{{
          $t('cont.t03')
        }}</span>
        <span class="tabs_item" @click="tabsFun(3)" :class="tabsActive === 3 ? 'tabs_active' : ''">{{
          $t('cont.t04')
        }}</span>
        <span class="tabs_item" @click="tabsFun(4)" :class="tabsActive === 4 ? 'tabs_active' : ''">{{
          $t('cont.t05')
        }}</span>
      </div>
      <div class="list">

        <div class="list_item" v-for="(item, index) in orderList" :key="index">
          <div class="item_top">
            <div class="time">
              {{ formatDate(item.endtime) }}
            </div>
            <div class="type">
              <!--已完成status===1-->
              <span v-if="item.status === 1">{{ $t('cont.t04') }}</span>
              <!--待处理status===0-->
              <span v-else-if="item.status === 0">{{ $t('cont.t03') }}</span>
              <!--冻结中status===5-->
              <span v-else-if="item.status === 5">{{ $t('cont.t05') }}</span>
              <!--未完成-->
              <span v-else>{{ $t('cont.t07') }}</span>
            </div>
          </div>

          <div class="item_con">
            <img :src="item.goods_pic" alt="">
            <div>
              <p style="color: #000;font-weight: 700;">{{ item.goods_name }}</p>
              <p>{{ item.shop_name }}</p>
              <p style="font-size: .26rem;line-height: .27rem;">{{ item.synopsis }}</p>
            </div>
          </div>

          <div class="item_info">
            <p>{{ $t('cont.t08') }}:</p>
            <span>${{ item.num }}</span>
          </div>

          <div class="item_info" style="margin-top: .1rem">
            <p>{{ $t('cont.t09') }}:</p>
            <span>${{ item.commission }}</span>
          </div>
          <div class="upBtn" v-if="item.status === 0" @click="upOid(item.id)">
            {{ $t('cont.t15') }}
          </div>
        </div>
      </div>
    </div>
    <!--订单弹窗-->
    <upOrder :show="upOrderDialog" v-if="upOrderDialog" :oid="orderOid" @data-sent="emitFun" @load="load" />
  </div>
</template>
<script>
import navs from "@/components/navs.vue";
import { SERVERTAPI } from '@/config'
import upOrder from "@/components/upOrder.vue";

export default {
  components: {
    upOrder,
    navs
  },
  data() {
    return {
      upOrderDialog: false, // 订单弹窗
      orderOid: '',  // 订单id
      apiSrc: SERVERTAPI,
      tabsActive: 1,
      orderList: [],
      orderObj: {
        1: [],
        2: [],
        3: [],
        4: []
      }
    }
  },
  mounted() {

  },
  destroyed() {

  },
  created() {
    this.getOrderData(this.tabsActive)
  },
  computed: {},
  methods: {
    load() {
      location.reload()
    },
    tabsFun(num) {
      this.tabsActive = num;
      this.getOrderData(num);

    },
    getOrderData(num) {
      if (this.orderObj[num].length !== 0) {
        this.orderList = this.orderObj[num];
        return;
      }
      this.orderList = [];
      const obj = {
        1: '',
        2: -1,
        3: 1,
        4: 5,
      }
      this.$http.getorder(obj[num]).then(res => {
        if (res.code === 0) {
          this.orderObj[num] = res.data;
          this.orderList = this.orderObj[num];
        } else {
          this.$toast(res.info);
        }
      })
    },
    // 大陆时间
    // formatDate(value) {
    //   if (!value) return ''
    //   let date = new Date(value * 1000)
    //   let year = date.getFullYear()
    //   let month = (date.getMonth() + 1).toString().padStart(2, '0')
    //   let day = date.getDate().toString().padStart(2, '0')
    //   let hour = date.getHours().toString().padStart(2, '0')
    //   let minute = date.getMinutes().toString().padStart(2, '0')
    //   let second = date.getSeconds().toString().padStart(2, '0')
    //   return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    // },

    // 大陆时间 -1天
    formatDate(value) {
      if (!value) return ''
      let date = new Date(value * 1000)
      date.setDate(date.getDate() - 1)
      let year = date.getFullYear()
      let month = (date.getMonth() + 1).toString().padStart(2, '0')
      let day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    // 订单弹窗回调
    emitFun(data) {
      this.upOrderDialog = !data;
    },
    // 提交订单
    upOid(oid) {
      this.orderOid = oid;
      this.upOrderDialog = true
    }
  },
}
</script>
<style lang='less' scoped>
.material-icons {
  color: #fff;
  font-size: .64rem;
}

.order {
  padding-top: 1.3rem;
  min-height: 100vh;

  .order_con {
    padding: 0 .4rem;

    .tabs {
      .tabs_item {
        padding: .1rem .2rem;
        color: #fff;
        font-size: .32rem;
        transition: color .4s;
      }

      .tabs_active {
        border: .003rem solid #fff;
        border-radius: .3rem;
        animation-name: fadeColor;
        animation-duration: 1s;
      }

      @keyframes fadeColor {
        from {
          color: #fff;
        }

        50% {
          color: #262626;
        }

        to {
          color: #fff;
        }
      }
    }

    .list {
      margin-top: .6rem;

      .list_item {
        padding: .37rem;
        // background-color: white;
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: .26rem;
        margin-bottom: .42rem;

        .item_top {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .time {
            font-size: .28rem;
            color: #666;
          }

          .type {
            font-size: .32rem;
            background-color: #FFBB00;
            padding: 0 .26rem;
            border-radius: .8rem;
            color: #212529;
          }
        }

        .item_con {
          display: flex;
          margin: .4rem 0;
          gap: .3rem;

          img {
            width: 1.6rem;
            height: 1.6rem;
          }

          div {
            flex: 1;

            p {
              font-size: .3rem;
              color: #666;
            }
          }


        }

        .item_info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: .37rem;

          p {
            color: #666;
            font-size: .32rem;
            font-weight: 700;
          }

          span {
            color: #666;
            font-size: .28rem;
            font-weight: 700;
          }
        }

        .upBtn {
          margin-top: .7rem;
          background-color: #121212;
          color: #fff;
          font-size: .3rem;
          border-radius: .2rem;
          text-align: center;
          padding: .3rem 0;
          font-weight: 700;
        }

      }
    }
  }

}

::v-deep {
  .top {
    background-color: #121212;
    border-bottom: #444 .04rem solid;
  }
}
</style>
